import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import Forces from '../math/Forces';

export default class MrBee extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, isSmall = false) {
    super(scene);

    this.hovering = false;

    // Animation, texture packers new version is whacky w/ animation, come up w/ better way
    this.curAnimation = 0;
    this.animationCount = 3;
    this.spritePrefix = 'MrBee0';
    this.animationWaiter = null;
    this.animationTime = .005;

    this.mass = 1;
    this.charge = 0;
    this.gravity = 50;
    this.kSpring = 10;
    this.cDamping = 0.9;

    this.timeAtPoint = 0;
    this.timeForStill = 1;

    this.angle = null;
    this.speed = null;
    this.ease = 0.13;
    this.distanceToTarget = 0;
    this.distanceTraveled = 0;
    this.direction = null;

    this.moveState = 10;
    this.sizeScale = 1.0;
    this.isSmall = false;

    this.workingWidth = 0;
    this.workingHeight = 0;
    this.waiter = 0;

    if (isSmall === true) {
      this.isSmall = true;
      this.spritePrefix = 'smMrBee0';
    }

    this.sprite = ABCyaPhaser.Images.addImage(0,0,`${this.spritePrefix}1`,this).setOrigin(0);
    this.workingWidth = this.sprite.width;
    this.workingHeight = this.sprite.height;

    this.pos = new Phaser.Math.Vector2();
    this.vel = new Phaser.Math.Vector2();
    this.acc = new Phaser.Math.Vector2();
    this.attractor = new Phaser.Math.Vector2();

    this.omega = Math.sqrt(this.kSpring / this.mass);
    this.A = new Phaser.Math.Vector2(this.pos.x, this.pos.y);
    this.A.subtract({ x: this.attractor.x, y: this.attractor.y });
    this.B = new Phaser.Math.Vector2(this.vel.x, this.vel.y);
    this.B.multiply({ x: 1 / this.omega, y: 1 / this.omega });

    this.displ = new Phaser.Math.Vector2();
    this.springForce = new Phaser.Math.Vector2();
    this.dampForce = new Phaser.Math.Vector2();
    this.bobForce = new Phaser.Math.Vector2();
    this.totalForce = new Phaser.Math.Vector2();

    this.timeElapsed = 0;

    this.destPos = new Phaser.Math.Vector2();
    this.startPos = new Phaser.Math.Vector2();
  }

  setPosAndAttractor (x,y,xoff, yoff) {
    this.pos.x = x;
    this.pos.y = y;
    this.attractor.x = x + xoff;
    this.attractor.y = y + yoff;
  }

  doSting () {
    this.moveState = STATE_STINGING;
    if (this.isSmall) {
      this.sprite.setFrame(UIAssetKeys._smMrBee_Sting).setOrigin(0);
    }
    else {
      this.sprite.setFrame(UIAssetKeys._MrBee_Sting).setOrigin(0);
    }

    this.waiter = 0.32;
  }

  turn (value) {
    this.scaleX = this.sizeScale * value;
  }

  initForceMove (x,y) {
    this.moveState = STATE_FORCES;
    this.attractor.x = x;
    this.attractor.y = y;
  }

  initMoveTo (destX, destY, speed = 13) {
    this.moveState = STATE_TO_POINT;
    this.startPos.x = this.x;
    this.pos.x = this.x;
    this.startPos.y = this.y;
    this.pos.y = this.y;
    this.destPos.x = destX;
    this.destPos.y = destY;
    this.speed = speed * 60;// multiply by 60 to get the speed per second instead of the speed per frame

    const direction = this.destPos.x - this.pos.x;
    if (direction > 0) {
      this.scaleX = -this.sizeScale;
    }
    else {
      this.scaleX = this.sizeScale;
    }
    this.ease = 0.8;
    this.angle = Math.atan2(destY - this.pos.y, destX - this.pos.x);
    this.distanceToTarget = Phaser.Math.Distance.BetweenPoints(this.pos, this.destPos);
    this.distanceTraveled = 0;
  }

  tick (deltaSeconds) {
    const d = deltaSeconds;
    this.timeElapsed += d;

    this.moveUpdate();

    switch (this.moveState) {

      case STATE_FORCES:
        this.animationTick(d);
        this.forcesMove(d);
        break;

      case STATE_TO_POINT:
        this.animationTick(d);
        this.incrementalMove(d);
        break;

      case STATE_STINGING:
        this.stingTick(d);
        break;
    }
  }

  moveUpdate () {
    this.x = this.pos.x;
    this.y = this.pos.y;
  }

  animationTick (d) {
    // Animation
    if (this.animationWaiter <= 0) {
      this.curAnimation++;
      if (this.curAnimation > this.animationCount) this.curAnimation = 1;
      this.sprite.setFrame(this.spritePrefix + this.curAnimation).setOrigin(0);
      this.animationWaiter = this.animationTime;
    }
    else {
      this.animationWaiter -= d;
    }
  }

  forcesMove (d) {
    this.pos.add({ x: this.vel.x * d, y: this.vel.y * d });
    this.calcForce();
    this.applyAccel();
    this.applyVelocity(d);
  }

  calcForce () {
    this.displ.set(this.pos.x - this.attractor.x, this.pos.y - this.attractor.y);

    Forces.spring(this.springForce, this.kSpring, this.displ);
    Forces.damping(this.cDamping, this.vel, this.dampForce);
    if (this.hovering) {
      const max = 500;
      const x = (max * (Math.random() - 0.5)) * Math.cos(2 * this.omega * this.timeElapsed) + (max * (Math.random() - 0.5)) * Math.sin(2 * this.omega * this.timeElapsed);
      const y = (max * (Math.random() - 0.5)) * Math.cos(2 * this.omega * this.timeElapsed) + (max * (Math.random() - 0.5)) * Math.sin(2 * this.omega * this.timeElapsed);
      this.bobForce.set(x,y);
    }
    else {
      this.bobForce.reset();
    }
    Forces.add([this.springForce, this.dampForce, this.bobForce], this.totalForce);
  }

  applyAccel () {
    this.acc.set(this.totalForce.x, this.totalForce.y);
    this.acc.multiply({ x: 1 / this.mass, y: 1 / this.mass });
  }

  applyVelocity (d) {
    this.vel.add({ x: this.acc.x * d, y: this.acc.y * d });
  }

  incrementalMove (d) {
    const workingX = this.pos.x + Math.cos(this.angle) * this.speed * this.ease * d;
    const workingY = this.pos.y + Math.sin(this.angle) * this.speed * this.ease * d;
    this.distanceTraveled = Phaser.Math.Distance.BetweenPoints(this.startPos, { x: workingX,y: workingY });
    if (this.distanceTraveled >= this.distanceToTarget) {
      this.emit('ARRIVED');
      this.pos.x = this.destPos.x;
      this.pos.y = this.destPos.y;
    }
    else {
      this.pos.x = workingX;
      this.pos.y = workingY;
    }
  }

  stingTick (d) {
    if (this.waiter <= 0) {
      this.emit('STING');
    }
    else {
      this.waiter -= d;
    }
  }
}

const STATE_FORCES = 10;
const STATE_TO_POINT = 20;
const STATE_STINGING = 30;